import * as React from "react";
const SvgFiRrSalaryAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-salary-alt_svg__a)">
      <path
        fill="#062147"
        d="M22.229 9.336 20 7.12V5c0-2.757-2.243-5-5-5H9C6.243 0 4 2.243 4 5v2.074L1.758 9.317A5.96 5.96 0 0 0 0 13.559v5.44c0 1.336.52 2.592 1.464 3.536A4.97 4.97 0 0 0 5 24h13.999c2.757 0 5-2.243 5-5v-5.408a6.04 6.04 0 0 0-1.77-4.256M6 5c0-1.654 1.346-3 3-3h6c1.654 0 3 1.346 3 3v7.273l-3.849 3.848c-1.131 1.131-3.112 1.129-4.243 0L6 12.212zm16 14c0 1.654-1.346 3-3 3H5.001a2.98 2.98 0 0 1-2.122-.879 2.98 2.98 0 0 1-.878-2.122v-5.441c0-.707.198-1.378.54-1.976l5.953 5.954a4.97 4.97 0 0 0 3.536 1.46 4.97 4.97 0 0 0 3.535-1.461l5.9-5.9c.335.596.534 1.267.534 1.956v5.408zM8 5.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 8 5.5m5 0a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 13 5.5M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-salary-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSalaryAlt;
